import { RetirementSavingsLoanParametersComponent } from './pages/retirement-savings-loan-parameters/retirement-savings-loan-parameters.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { ChartsModule, ThemeService  } from 'ng2-charts';

// Material Components
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule, MatListModule, MatIconModule, MatBadgeModule } from '@angular/material';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { LayoutModule } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material';
import { MatSortModule } from '@angular/material';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorIntl } from '@angular/material';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { HttpClientModule } from '@angular/common/http';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

///////////////////////////////////////////////////////module
import { ContractStateModule} from './../modules/contract-state/state.module'

///////////////////////////////////////////////////////
// services
import { MaPaginatorIntlES } from '../services/MaPaginatorIntlES';
import { InstantSearchService } from '../services/instantsearch.service';
import { UploadService } from '../services/upload.service';
import { LogicService } from '../services/logic.service';
import { PendingLoanRequestLogicService } from '../services/pending-loan-request-logic.service';

///////////////////////////////////////////////////////
// routing
import { AuthenticatedRoutingModule } from './authenticated-routing.module';

///////////////////////////////////////////////////////
// Component
import { RootDashboardComponent } from './root-dashboard/root-dashboard.component';

///////////////////////////////////////////////////////
// Component
import { OnlyNumberDirective } from '../directives/only-number.directive';
import { UtcPipe } from '../services/utcDatePipe';
import { DateFormatPipe } from '../services/dateFormatPipe';
import { EmployeeHomeComponent } from './pages/employee-home/employee-home.component';
import { EmployeeProfileComponent } from './pages/employee-profile/employee-profile.component';
import { LoanApprovalComponent } from './pages/loan-approval/loan-approval.component';
import { HeaderComponent } from './components/header/header.component';
import { PsRegistrationComponent } from './components/permanent/savings/ps-registration/ps-registration.component';
import { PsDetailsComponent } from './components/permanent/savings/ps-details/ps-details.component';
import { PsCancellationComponent } from './components/permanent/savings/ps-cancellation/ps-cancellation.component';
import { PsWithdrawComponent } from './components/permanent/savings/ps-withdraw/ps-withdraw.component';
import { PsReRegistrationComponent } from './components/permanent/savings/ps-re-registration/ps-re-registration.component';
import { PsEditRegistrationComponent } from './components/permanent/savings/ps-edit-registration/ps-edit-registration.component';
import { PlRequestComponent } from './components/permanent/loans/pl-request/pl-request.component';
import { PlDetailsComponent } from './components/permanent/loans/pl-details/pl-details.component';
import { EmployeeRefComponent } from './components/employee-ref/employee-ref.component';
import { PsStatementComponent } from './components/permanent/savings/ps-statement/ps-statement.component';
import { RlDetailsComponent } from './components/retirement/loan/rl-details/rl-details.component';
import { RlRequestComponent } from './components/retirement/loan/rl-request/rl-request.component';
import { RsStatementComponent } from './components/retirement/savings/rs-statement/rs-statement.component';
import { LsfStatementComponent } from './components/saving-fund/lsf-statement/lsf-statement.component';
import { EmployeeGeneralInformationComponent } from './components/employee-general-information/employee-general-information.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { WorkInformationComponent } from './components/work-information/work-information.component';
import { EmployeeDetailsComponent } from './pages/employee-details/employee-details.component';
import { EmployeeListComponent } from './pages/employee-list/employee-list.component';
import { PendingRequestComponent } from './pages/pending-request/pending-request.component';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { PayrollComponent } from './components/payroll/payroll.component';
import { PayrollDatesComponent } from './pages/payroll-dates/payroll-dates.component';
import { PermanentSavingsParametersComponent } from './pages/permanent-savings-parameters/permanent-savings-parameters.component';
import { PsParametersComponent } from './components/permanent/savings/ps-parameters/ps-parameters.component';
import { PermanentSavingsLoanParametersComponent } from './pages/permanent-savings-loan-parameters/permanent-savings-loan-parameters.component';
import { PermanentInstallmentParametersComponent } from './pages/permanent-installment-parameters/permanent-installment-parameters.component';
import { PermanentSavingInvestmentsComponent } from './pages/permanent-saving-investments/permanent-saving-investments.component';
import { RlParametersComponent } from './components/retirement/loan/rl-parameters/rl-parameters.component';
import { RetirementSavingParametersComponent } from './pages/retirement-saving-parameters/retirement-saving-parameters.component';
import { RsParametersComponent } from './components/retirement/savings/rs-parameters/rs-parameters.component';
import { SavingFundParametersComponent } from './pages/saving-fund-parameters/saving-fund-parameters.component';
import { LsfParametersComponent } from './components/saving-fund/lsf-parameters/lsf-parameters.component';
import { PendingListComponent } from './pages/pending-list/pending-list.component';
import { LoansWaitingListComponent } from './pages/loans-waiting-list/loans-waiting-list.component';
import { PendingListParametersComponent } from './pages/pending-list-parameters/pending-list-parameters.component';
import { PendingListParametersOptionsComponent } from './pages/pending-list-parameters-options/pending-list-parameters-options.component';
import { PsParametersContributionComponent } from './components/permanent/savings/ps-parameters-contribution/ps-parameters-contribution.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DashboardEmployeeComponent } from './pages/dashboard-employee/dashboard-employee.component';
import { SsRegistrationComponent } from './components/share-saving/ss-registration/ss-registration.component';
import { SsParametersComponent } from './components/share-saving/ss-parameters/ss-parameters.component';
import { ShareSavingParametersComponent } from './pages/share-saving-parameters/share-saving-parameters.component';
import { SsUserRegistrationComponent } from './components/share-saving/ss-user-registration/ss-user-registration.component';
import { SsApprovalComponent } from './components/share-saving/ss-approval/ss-approval.component';
import { SsUserComponent } from './components/share-saving/ss-user/ss-user.component';
import { VeabRegistrationComponent } from './components/veab-registration/veab-registration.component';


@NgModule({
  declarations: [
    UtcPipe,
    DateFormatPipe,
    RootDashboardComponent,
    OnlyNumberDirective,
    EmployeeHomeComponent,
    EmployeeProfileComponent,
    LoanApprovalComponent,
    PsRegistrationComponent,
    PsDetailsComponent,
    PsCancellationComponent,
    PsWithdrawComponent,
    PsReRegistrationComponent,
    PsEditRegistrationComponent,
    PlRequestComponent,
    PlDetailsComponent,
    EmployeeRefComponent,
    PsStatementComponent,
    RlDetailsComponent,
    RlRequestComponent,
    RsStatementComponent,
    LsfStatementComponent,
    ContactInformationComponent,
    EmployeeGeneralInformationComponent,
    WorkInformationComponent,
    HeaderComponent,
    EmployeeListComponent,
    PendingRequestComponent,
    ReportPageComponent,
    PayrollComponent,
    PayrollDatesComponent,
    PermanentSavingsParametersComponent,
    PsParametersComponent,
    PermanentSavingsLoanParametersComponent,
    PermanentInstallmentParametersComponent,
    PermanentSavingInvestmentsComponent,
    RetirementSavingsLoanParametersComponent,
    RetirementSavingParametersComponent,
    RsParametersComponent,
    RlParametersComponent,
    SavingFundParametersComponent,
    LsfParametersComponent,
    EmployeeDetailsComponent,
    PendingListComponent,
    LoansWaitingListComponent,
    PendingListParametersComponent,
    PendingListParametersOptionsComponent,
    PsParametersContributionComponent,
    DashboardComponent,
    DashboardEmployeeComponent,
    SsRegistrationComponent,
    SsParametersComponent,
    ShareSavingParametersComponent,
    SsUserRegistrationComponent,
    SsApprovalComponent,
    SsUserComponent,
    VeabRegistrationComponent
    ],
  imports: [
    CommonModule,
    CustomFormsModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    MatSidenavModule,
    LayoutModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatSelectModule,
    MatMenuModule,
    MatButtonModule,
    MatTabsModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatBadgeModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatCardModule,
    HttpClientModule,
    AuthenticatedRoutingModule,
    ContractStateModule
  ],
  providers: [
    ThemeService,
    MomentDateAdapter,
    { provide: MatPaginatorIntl, useClass: MaPaginatorIntlES },
    InstantSearchService,
    UploadService,
    LogicService,
    PendingLoanRequestLogicService
  ],
})
export class AuthenticatedModule { }
